var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            ref: "dataTable",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.auditRecList,
              border: "",
              maxHeight: "400",
              "tooltip-effect": "dark"
            }
          },
          [
            _c("el-table-column", {
              attrs: {
                align: "center",
                prop: "auditTime",
                label: "操作时间",
                width: "160"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "auditBizUnitName",
                label: "部门",
                width: "200",
                "show-overflow-tooltip": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.auditorDepartFullName != null
                        ? _c("span", [
                            _vm._v(_vm._s(rows.row.auditorDepartFullName))
                          ])
                        : _c("span", [
                            _vm._v(_vm._s(rows.row.auditBizUnitName))
                          ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "auditorPostName",
                label: "岗位",
                width: "150",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "auditorName",
                label: "操作人",
                width: "150",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "auditDesc",
                label: "审核描述",
                "show-overflow-tooltip": ""
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-718ec1b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-718ec1b9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/devcMerge/DevcMergeAuditRecList.vue
// module id = 2647
// module chunks = 0